import type { FC } from "react";

import type { StoreLocatorFilterItem } from "@locators/components/shared/types";
import { getStoreFilterCategoryIcon } from "@locators/components/shared/utils/getStoreFiltersIcons";

import { RadioCard } from "@jti/ui/components/RadioCard";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import styles from "./StoreLocatorFilterCategory.module.scss";

type StoreLocatorFilterCategoryItemProps = {
  filter: StoreLocatorFilterItem;
  onChange: () => void;
  isChecked: boolean;
  filterCategory: string;
};

export const StoreLocatorFilterCategoryItem: FC<StoreLocatorFilterCategoryItemProps> = ({
  filter,
  onChange,
  isChecked,
  filterCategory,
}) => {
  const { __ } = useTranslations();
  const { label, value } = filter;

  return (
    <RadioCard
      value={value ?? filter.key}
      onChange={onChange}
      title={label ?? filter.name}
      groupName={filterCategory}
      isChecked={isChecked}
      type="checkbox"
      icon={getStoreFilterCategoryIcon({
        categoryKey: filterCategory,
        filterKey: filter.key,
        colorsClassName: styles.colors,
        filtersItemIconContainerClassName: styles.filtersItemIconContainer,
      })}
    />
  );
};
